<div class="main-content">

    <div class="d-flex flex-row px-mb-20 chart-row main_div_style">
        <div class="w-33">
            <div class="card">
                <div class="card-header table-card-header d-flex flex-row">
                    <div class="me-auto">
                        CCR
                    </div>
                </div>
                <div class="custom-card-body px-p-10" *ngIf="!counterPartyCcrEceChartData">
                    <span class="title2">Loading, Please wait...</span>
                </div>
                <div class="custom-card-body px-p-10"
                     *ngIf="counterPartyCcrEceChartData && counterPartyCcrEceChartData.length === 0">
                    <span class="title2">No data</span>
                </div>
                <div class="custom-card-body"
                     *ngIf="counterPartyCcrEceChartData && counterPartyCcrEceChartData.length > 0">
                    <div class=" px-py-5 px-px-10 bb-sterling-grey px-mb-10">
                        <div class="bnpp-btn-group btn-group btn-group-toggle" name="radioBasic" role="group">

                             <input type="radio" [(ngModel)]="selectedCcrEceChartOption" name="btnradio"
                             value="0.5" class="btn-check" id="CCR1W" autocomplete="off">
                            <label class=" btn" [ngClass]="selectedCcrEceChartOption =='0.5' ? 'active':''" for="CCR1W">1W</label>

                            <input type="radio" [(ngModel)]="selectedCcrEceChartOption" name="btnradio" value="1" class="btn-check" id="CCR1M" autocomplete="off">
                            <label class="btn" [ngClass]="selectedCcrEceChartOption =='1' ? 'active':''" for="CCR1M">1M</label>

                            <input type="radio" [(ngModel)]="selectedCcrEceChartOption" name="btnradio" value="6" class="btn-check" id="CCR6M" autocomplete="off">
                            <label class="btn" [ngClass]="selectedCcrEceChartOption =='6' ? 'active':''" for="CCR6M">6M</label>

                            <input type="radio" [(ngModel)]="selectedCcrEceChartOption" name="btnradio" value="12" class="btn-check" id="CCR1Y" autocomplete="off">
                            <label class="btn" [ngClass]="selectedCcrEceChartOption =='12' ? 'active':''" for="CCR1Y">1Y</label>

                            <!--<label ngbButtonLabel class="ms-1">
                                <input ngbButton type="radio" value="0.5"> 1W
                            </label>
                            <label ngbButtonLabel class="ms-2">
                                <input ngbButton type="radio" value="1"> 1M
                            </label>
                            <label ngbButtonLabel class="ms-2">
                                <input ngbButton type="radio" value="6"> 6M
                            </label>
                            <label ngbButtonLabel class="ms-2 me-1">
                                <input ngbButton type="radio" value="12"> 1Y
                            </label>-->
                        </div>
                    </div>
                    <div class="with-tool-bar">
                        <div class="d-flex flex-row justify-content-between chart-yaxis-title px-px-5">
                            <span>CCR %</span>
                        </div>
                        <app-counter-party-ccr-ece-chart
                            [counterPartyCcrEceChartData]="counterPartyCcrEceChartData"
                            [periodLength]="selectedCcrEceChartOption"
                            (ccrTimeStepClick)="onCcrTimeStepClick($event)"></app-counter-party-ccr-ece-chart>
                    </div>

                </div>
            </div>
        </div>
        <div class="w-33 ms-3">
            <div class="card px-ms-10">
                <div class="card-header table-card-header d-flex flex-row">
                    <div class="me-auto">
                        Derivatives vs Collateral
                    </div>
                </div>
                <div class="custom-card-body px-p-10" *ngIf="!derivativesVsCollateralChartData">
                    <span class="title2">Loading, Please wait...</span>
                </div>
                <div class="custom-card-body px-p-10"
                     *ngIf="derivativesVsCollateralChartData && derivativesVsCollateralChartData.length === 0">
                    <span class="title2">No data</span>
                </div>
                <div class="custom-card-body"
                     *ngIf="derivativesVsCollateralChartData && derivativesVsCollateralChartData.length > 0">
                    <div class=" px-py-5 px-px-10 bb-sterling-grey px-mb-10">
                        <div class="bnpp-btn-group btn-group btn-group-toggle"  name="radioBasic" role="group">

                             <input type="radio" [(ngModel)]="selectedDerivativesCollateralChartOption" name="btnradio"
                              value="0.5" class="btn-check" id="1W" autocomplete="off">
                             <label class=" btn" [ngClass]="selectedDerivativesCollateralChartOption =='0.5' ? 'active':''" for="1W">1W</label>
 
                             <input type="radio" [(ngModel)]="selectedDerivativesCollateralChartOption" name="btnradio" value="1" class="btn-check" id="1M" autocomplete="off">
                             <label class="btn" [ngClass]="selectedDerivativesCollateralChartOption =='1' ? 'active':''" for="1M">1M</label>
 
                             <input type="radio" [(ngModel)]="selectedDerivativesCollateralChartOption" name="btnradio" value="6" class="btn-check" id="6M" autocomplete="off">
                             <label class="btn" [ngClass]="selectedDerivativesCollateralChartOption =='6' ? 'active':''" for="6M">6M</label>

                             <input type="radio" [(ngModel)]="selectedDerivativesCollateralChartOption" name="btnradio" value="12" class="btn-check" id="1Y" autocomplete="off">
                             <label class="btn" [ngClass]="selectedDerivativesCollateralChartOption =='12' ? 'active':''" for="1Y">1Y</label>
                            <!--<label ngbButtonLabel class="ms-1">
                                <input ngbButton type="radio" value="0.5"> 1W
                            </label>
                            <label ngbButtonLabel class="ms-2">
                                <input ngbButton type="radio" value="1"> 1M
                            </label>
                            <label ngbButtonLabel class="ms-2">
                                <input ngbButton type="radio" value="6"> 6M
                            </label>
                            <label ngbButtonLabel class="ms-2 me-1">
                                <input ngbButton type="radio" value="12"> 1Y
                            </label>-->
                        </div>
                    </div>
                    <div class="with-tool-bar">
                        <div class="d-flex flex-row justify-content-between chart-yaxis-title px-px-5">
                            <span>DER M USD</span>
                            <span>COL M USD</span>
                        </div>
                        <app-derivatives-vs-collateral-chart
                            [derivativesVsCollateralChartData]="derivativesVsCollateralChartData"
                            [periodLength]="selectedDerivativesCollateralChartOption"></app-derivatives-vs-collateral-chart>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-33 ms-3">
            <div class="card px-ms-10">
                <div class="card-header table-card-header bb-none">
                    <div class="me-auto">
                        WCCR PERIODS
                    </div>
                </div>
                <div class="custom-card-body px-p-10 bt-sterling-grey" *ngIf="!wccrPeriodGridData">
                    <span class="title2">Loading, Please wait...</span>
                </div>
                
                <div class="custom-card-body d-flex flex-column" *ngIf="wccrPeriodGridData">
                    <div class="card_style">
                        <div class="ag-fresh ag-grid_style">
                            <ag-grid-angular
                                         [columnDefs]="wccrPeriodGridColumnDef"
                                         [rowData]="wccrPeriodGridData"
                                         [overlayLoadingTemplate]="overlayLoadingTemplate"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         [suppressCellSelection]="true"
                                         (gridReady)="onWccrPeriodGridReady($event)">
                           </ag-grid-angular>
                       </div>
                   </div>
                </div>
            </div>
        </div>
    </div>

    <div>
        <div class="card">
            <div class="card-header table-card-header d-flex flex-row px-ps-10">
                <div class="me-auto px-ms-5">
                    INSTRUMENTS
                </div>
            </div>
            <div class="card-header table-card-header grid-control-bar d-flex flex-row bnpp-regular">
                <app-horizon-time-range *ngIf="!ccrTimeStepClickFilter" [horizon]="instrumentGridToolBarOption.horizon"
                                        (updateHorizonTimeRange)="onUpdateHorizonTimeRange($event)"></app-horizon-time-range>
                <div class="custom-form-inline me-auto">
                    <div *ngIf="!ccrTimeStepClickFilter">
                        <span class="px-ms-20 ms-2">Instruments:&nbsp; </span>
                        <div class="bnpp-btn-group btn-group btn-group-toggle" role="group" ngbRadioGroup name="radioBasic"
                             [(ngModel)]="instrumentGridToolBarOption.instrumentType"
                             (ngModelChange)="selectedGridInstrumentTypeChange($event)">

                             <input type="radio" [(ngModel)]="instrumentGridToolBarOption.instrumentType"
                            (ngModelChange)="selectedGridInstrumentTypeChange($event)" name="btnradio"
                             value="-1" class="btn-check" id="all" autocomplete="off">
                            <label class=" btn" [ngClass]="instrumentGridToolBarOption.instrumentType =='-1' ? 'active':''" for="all">All</label>

                            <input type="radio" [(ngModel)]="instrumentGridToolBarOption.instrumentType"
                            (ngModelChange)="selectedGridInstrumentTypeChange($event)" name="btnradio" value="0" class="btn-check" id="derivatives" autocomplete="off">
                            <label class="btn" [ngClass]="instrumentGridToolBarOption.instrumentType =='0' ? 'active':''" for="derivatives">Derivatives</label>

                            <input type="radio" [(ngModel)]="instrumentGridToolBarOption.instrumentType"
                            (ngModelChange)="selectedGridInstrumentTypeChange($event)" name="btnradio" value="1" class="btn-check" id="collateral" autocomplete="off">
                            <label class="btn" [ngClass]="instrumentGridToolBarOption.instrumentType =='1' ? 'active':''" for="collateral">Collateral</label>

                            <!--<label ngbButtonLabel class="ms-1">
                                <input ngbButton type="radio" value="-1"> All
                            </label>
                            <label ngbButtonLabel class="ms-2">
                                <input ngbButton type="radio" value="0"> Derivatives
                            </label>
                            <label ngbButtonLabel class="ms-2 me-1">
                                <input ngbButton type="radio" value="1"> Collateral
                            </label>-->
                        </div>
                    </div>
                </div>

                <div class="form-inline bg-bnpp-orange2 color-white px-me-20 px-pe-5 br-2" *ngIf="ccrTimeStepClickFilter">
                    <div class="px-px-10">
                        <div *ngIf="ccrTimeStepClickFilter.endDate">Only show bonds expiring between {{ccrTimeStepClickFilter.startDate}} and
                            {{ccrTimeStepClickFilter.endDate}}</div>
                        <div *ngIf="!ccrTimeStepClickFilter.endDate">Only show bonds expiring after {{ccrTimeStepClickFilter.startDate}} </div>
                    </div>
                    <span class="logo-btn-small close white" (click)="removeExpiredBondFilter()"></span>
                </div>

                <div class="form-inline my-2 my-lg-0">
                    <input class="form-control me-sm-2 form-control-sm grid-filter" type="search" placeholder="Search"
                           [(ngModel)]="instrumentGridToolBarOption.searchText" aria-label="Search">
                </div>
            </div>
            <div class="ag-fresh grid_style">
                <ag-grid-angular
                                 [gridOptions]="instrumentGridOptions"
                                 [components]="components"
                                 [quickFilterText]="instrumentGridToolBarOption.searchText"
                                 [columnDefs]="instrumentGridColumnDef"
                                 [rowData]="instrumentGridData"
                                 [overlayLoadingTemplate]="overlayLoadingTemplate"
                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                 [suppressRowDeselection]="true"
                                 [rowClassRules]="rowClassRules"
                                 (gridReady)="onInstrumentGridReady($event)">
                </ag-grid-angular>
            </div>
        </div>
    </div>

</div>


